import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {API_URL} from "../../../../settings/local_settings";
import {Spinner} from "../../../Spinner";
import {APIClient} from "../../../../utils/APIClient";
import {CHANNEL_TYPE_PAID_MEDIA, CHANNEL_TYPE_ECOMMERCE, CHANNEL_TYPE_ANALYTICS, ChannelsHelper} from "../../../channels/channels";
import {AdAccountsMultiSelect} from "../../../selects/AdAccountsMultiSelect";
import { withTranslation } from 'react-i18next';


export class AddAccountFormClass extends Component {

    constructor(props) {
        super(props);

        this.state = {
            saving: false,
            agencyAdAccounts: null,
            selectedAdAccounts: null,
            adAccountsAlreadyInBusinessUnit: null,
            channelsConnections: null,
            agencyId: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.footerButton = this.footerButton.bind(this);
        this.handleAdAccountsChange = this.handleAdAccountsChange.bind(this);
    }

    componentDidMount() {
        this.getAgencyAdAccounts();
        this.getAdAccountsAlreadyInBusinessUnit();
        this.getAgencyChannelConnections();
        this.getAgencyId();
    }

    handleAdAccountsChange(selectedAdAccounts) {
        this.setState({
            ...this.state,
            selectedAdAccounts: selectedAdAccounts,
        });
    }

    // handlers

    submitUrl() {
        return `${API_URL}business-unit/${this.props.businessUnitId}/campaigns-configurations/add`;
    }

    getAgencyAdAccounts(){
        new APIClient(this.getBusinessUnitAllAdAccountsURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
                this.setState({
                    agencyChannels: []
                })
            } else if (response.status === 'OK') {
                this.setState({
                    agencyAdAccounts: response.data
                })
            }
        });
    }

    getAdAccountsAlreadyInBusinessUnit(){
        new APIClient(this.getAdAccountsAlreadyInBusinessUnitURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
                this.setState({
                    adAccountsAlreadyInBusinessUnit: null
                })
            } else if (response.status === 'OK') {
                this.setState({
                    adAccountsAlreadyInBusinessUnit: response.data
                })
            }
        });
    }

    getAgencyChannelConnections(){
        new APIClient(this.getAgencyChannelConnectionsURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
                this.setState({
                    channelsConnections: null
                })
            } else if (response.status === 'OK') {
                this.setState({
                    channelsConnections: {
                        'channelsAllowed': response.data['channels_allowed'],
                        'channelsWithConnection': response.data['channels_with_connection']
                    }
                })
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            saving: true
        });

        new APIClient(this.submitUrl()).call('POST', this.state.selectedAdAccounts).then((response) => {
            this.setState({
                saving: false
            });

            if (response.status !== 'OK') {
                alert(response.error_message);
            } else {
                this.props.afterSuccessfulSubmit(response.data.campaign_configuration_data_by_id)
            }
        });
    }

    // render

    render() {
        if (this._getItemsToList() === null || this.state.channelsConnections === null)
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>

        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <AdAccountsMultiSelect
                                                   //onRefreshListItems={"FEDE"}
                                                   longList={true}
                                                   onChange={this.handleAdAccountsChange}
                                                   selectedItemIds={[]}
                                                   channelsStatues={this.state.channelsStatues}
                                                   items={this._getItemsToList()}
                                                   channelsConnections={this.state.channelsConnections}
                                                   showChannelTypes={[CHANNEL_TYPE_PAID_MEDIA, CHANNEL_TYPE_ECOMMERCE, CHANNEL_TYPE_ANALYTICS]}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>
        )
    }

    _getItemsToList() {

        if(this.state.agencyAdAccounts === null || this.state.adAccountsAlreadyInBusinessUnit === null)
            return null;

        // Excluimos las cuestas que ya están en el presupuesto, y las que nunca pueden entrar en una línea
        // (la familia «Rentabilidad del negocio»: alimenta la economía del cliente, no una línea).
        let filteredAccounts = this.state.agencyAdAccounts.filter(aac => !this.state.adAccountsAlreadyInBusinessUnit.includes(aac.id)
            && ChannelsHelper.canBeInBusinessUnit(aac.channel));
        
        // FEDE: Parche temporal: solo permitir SHOPIFY, TIENDA_NUBE y ANALYTICS si la agencia tiene id 4 o 130
        // if (this.state.agencyId !== 4 && this.state.agencyId !== 130) {
        //     filteredAccounts = filteredAccounts.filter(aac => ![SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, ANALYTICS_CHANNEL].includes(aac.channel));
        // }
        
        return filteredAccounts;
    }

    footerButton() {
        const { t } = this.props;
        if (this.state.saving) {
            return <Spinner color="positive small"/>
        } else {
            return <input type="submit" value={t('add_account_form.next')} className="btn -submit"/>
        }
    }

    // aux

    getBusinessUnitAllAdAccountsURL() {
        return `${API_URL}business-unit/${this.props.businessUnitId}/all_ad_accounts`;
    }

    getAdAccountsAlreadyInBusinessUnitURL() {
        return `${API_URL}business-unit/${this.props.businessUnitId}/linked_ad_accounts`;
    }

    getAgencyChannelConnectionsURL() {
        return `${API_URL}agency/connections/`;
    }

    getAgencyId() {
        new APIClient(`${API_URL}get-agency-data/`).call('GET').then((response) => {
            if (response.status === 'OK' && response.general_data && response.general_data.id) {
                this.setState({
                    agencyId: response.general_data.id
                });
            }
        });
    }

}

export const AddAccountForm = withTranslation()(AddAccountFormClass);
export default AddAccountForm;
